import { SearchResult } from 'src/services/search/SearchDtos';

import { ResourceListItem } from 'src/types/ResourceListItem';

import { isLmsCourse } from 'src/utils/isTemplate';

import { parseWildCardUrl } from '../fields/parseUrl';

export function mapSearchResult(item: SearchResult, wildcardUrl?: string): ResourceListItem | null {
	try {
		if (!item.Title) {
			throw 'Null Argument Error - Search result must have a title';
		}

		let url = item.Url || item.SiteSpecificUrl || '';
		if (!isLmsCourse(item.TemplateId) && wildcardUrl) {
			url = parseWildCardUrl(item.Name, wildcardUrl);
		}

		const accessTypes = new Map<string, string>();
		item?.AccessTypes?.map((a) => accessTypes.set(a, a));

		return {
			Id: item.Id,
			Title: item.Title,
			Strapline: item.Strapline,
			Url: url,
			LearningType: item.LearningType,
			AccessTypes: accessTypes,
			AccessTypesString: item.AccessTypes?.join(', '),
			ImageUrl: item.ImageUrl,
			Tags: item.Tags,
			Cost: item.Cost,
			LearningFormats: item.LearningFormats,
			TypesOfResources: item.TypesOfResources,
			Location: item.Location,
			CpdHours: item.CpdHours,
		};
	} catch (error) {
		console.error(error);
		return null;
	}
}
